/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendD1OverviewResponseDto } from '../models/backend-d-1-overview-response-dto';
import { getOverviewEndpointDashboardsD1OverviewGet } from '../fn/dashboards/get-overview-endpoint-dashboards-d-1-overview-get';
import { GetOverviewEndpointDashboardsD1OverviewGet$Params } from '../fn/dashboards/get-overview-endpoint-dashboards-d-1-overview-get';
import { getPortfolioEndpointDashboardsD1PortfolioGet } from '../fn/dashboards/get-portfolio-endpoint-dashboards-d-1-portfolio-get';
import { GetPortfolioEndpointDashboardsD1PortfolioGet$Params } from '../fn/dashboards/get-portfolio-endpoint-dashboards-d-1-portfolio-get';
import { BackendPageD1PortfolioItemDto } from '../models/backend-page-d-1-portfolio-item-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiD1Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getOverviewEndpointDashboardsD1OverviewGet()` */
  static readonly GetOverviewEndpointDashboardsD1OverviewGetPath = '/dashboards/d1/overview';

  /**
   * D1: KPI активного сценария проекта (NPV, IRR, PI, MIRR, окупаемость, среднее за год, финансирование).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOverviewEndpointDashboardsD1OverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverviewEndpointDashboardsD1OverviewGet$Response(
    params: GetOverviewEndpointDashboardsD1OverviewGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD1OverviewResponseDto>> {
    return getOverviewEndpointDashboardsD1OverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D1: KPI активного сценария проекта (NPV, IRR, PI, MIRR, окупаемость, среднее за год, финансирование).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOverviewEndpointDashboardsD1OverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverviewEndpointDashboardsD1OverviewGet(
    params: GetOverviewEndpointDashboardsD1OverviewGet$Params,
    context?: HttpContext,
  ): Observable<BackendD1OverviewResponseDto> {
    return this.getOverviewEndpointDashboardsD1OverviewGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD1OverviewResponseDto>): BackendD1OverviewResponseDto => r.body),
    );
  }

  /** Path part for operation `getPortfolioEndpointDashboardsD1PortfolioGet()` */
  static readonly GetPortfolioEndpointDashboardsD1PortfolioGetPath = '/dashboards/d1/portfolio';

  /**
   * D1: таблица портфеля проектов (только для администраторов).
   *
   * Список всех активных проектов с их KPI. Доступен только пользователям с `is_admin=true`. Видимости «свои проекты» здесь нет — админ видит всё.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPortfolioEndpointDashboardsD1PortfolioGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPortfolioEndpointDashboardsD1PortfolioGet$Response(
    params?: GetPortfolioEndpointDashboardsD1PortfolioGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPageD1PortfolioItemDto>> {
    return getPortfolioEndpointDashboardsD1PortfolioGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D1: таблица портфеля проектов (только для администраторов).
   *
   * Список всех активных проектов с их KPI. Доступен только пользователям с `is_admin=true`. Видимости «свои проекты» здесь нет — админ видит всё.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPortfolioEndpointDashboardsD1PortfolioGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPortfolioEndpointDashboardsD1PortfolioGet(
    params?: GetPortfolioEndpointDashboardsD1PortfolioGet$Params,
    context?: HttpContext,
  ): Observable<BackendPageD1PortfolioItemDto> {
    return this.getPortfolioEndpointDashboardsD1PortfolioGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendPageD1PortfolioItemDto>): BackendPageD1PortfolioItemDto => r.body),
    );
  }
}
